import {alpha3ToAlpha2} from 'i18n-iso-countries';

import {countryPhoneCodeDictionary} from './dictionary';

export const getPhoneCodeByCountryCode = (countryCode: string) => {
  const isISO3 = countryCode.length === 3;
  const code = isISO3 ? alpha3ToAlpha2(countryCode) : countryCode;

  return countryPhoneCodeDictionary.find((item) => item.countryCode === code)?.phoneCode;
};

export {countryPhoneCodeDictionary} from './dictionary';
